import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SkipNav } from '@ver-uds/uswds-react';
import { PageHeader } from '@ver-uds/react';
import { useAuthState } from '@vis-auth/react';
import { AccountType } from 'eve-account-client';
import { useParams } from 'react-router-dom';
import { useAccountQuery } from '../services';

export type FullWidthLayoutProps = {
  children: React.ReactNode;
  title: string;
  headerTitle?: string;
  noPageHeader?: boolean;
};

const FullWidthLayout = ({ children, title, headerTitle, noPageHeader }: FullWidthLayoutProps): JSX.Element => {
  const { user } = useAuthState();
  // eslint-disable-next-line camelcase
  let accountId = user?.account_id as string;

  const { subAccountId } = useParams<{ subAccountId?: string }>();
  if (subAccountId) {
    accountId = subAccountId;
  }

  const { data: accountData } = useAccountQuery(accountId, {
    enabled: !headerTitle,
    queryKey: 'FullWidthLayoutAccountQuery',
  });

  let headerMessage = headerTitle as string;
  if (!headerTitle) {
    const accountType = accountData?.type;
    const companyName = accountData?.companyInfo.companyName;

    switch (accountType) {
      case AccountType.CORPORATE:
        headerMessage = 'My Corporate Account';
        break;
      // eslint-disable-next-line no-fallthrough
      case AccountType.CHILD:
        if (subAccountId) {
          headerMessage = companyName ? `Company Location: ${companyName}` : 'Company Location';
          break;
        }
      // else, fallthrough
      case AccountType.CLIENT:
        if (subAccountId) {
          headerMessage = companyName ? `Client Company: ${companyName}` : 'Client Company';
          break;
        }
      // else, fallthrough
      case AccountType.AGENCY:
      case AccountType.EMPLOYER:
        headerMessage = 'My Company Account';
        break;
      default:
        if (subAccountId) {
          headerMessage = companyName ?? 'Account';
        } else {
          headerMessage = 'My Account';
        }
        break;
    }
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      {!noPageHeader && <PageHeader>{headerMessage}</PageHeader>}

      <div className="grid-container display-flex flex-fill width-full">
        <div className="grid-col-12">
          <SkipNav.MainContent>{children}</SkipNav.MainContent>
        </div>
      </div>
    </>
  );
};

export default FullWidthLayout;
